<template>
  <b-card no-body>
    <b-card-header>
      <h4>{{ $t('bookings.price_offers_label') }}</h4>
    </b-card-header>

    <b-table :items="offers" :fields="fields" responsive>
      <template #index="{ index }">
        {{ index + 1 }}
      </template>
      <template #total_price="{ item }">
        <p>{{ item.total_price | currency('EUR') }}</p>
        <p v-if="showSystemInfo" class="text-muted">
          {{ item.company_price | currency('EUR') }}
        </p>
      </template>
      <template #created_at="{ value }">
        {{ value | moment($dateFormat) }}
      </template>
      <template #actions="{ item }">
        <b-button
          type="button"
          variant="primary"
          size="sm"
          @click="onAccept(item.id)"
        >
          {{ $t('bookings.price_offers.accept') }}
        </b-button>
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  name: 'PriceOffers',
  props: {
    offers: {
      required: true,
      type: Array,
    },
    showSystemInfo: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fields() {
      return [
        {
          key: 'index',
          label: '#',
        },
        ...(this.showSystemInfo
          ? [
              {
                key: 'id',
                label: this.$t('general.id'),
              },
              {
                key: 'company_name',
                label: this.$t('bookings.price_offers.company'),
              },
            ]
          : []),
        {
          key: 'total_price',
          label: this.$t('bookings.price_offers.price'),
        },
        {
          key: 'created_at',
          label: this.$t('general.date'),
        },
        {
          key: 'actions',
          label: this.$t('bookings.price_offers.actions'),
          class: 'text-center',
        },
      ]
    },
  },

  methods: {
    onAccept(id) {
      this.$emit('accept', id)
    },
  },
}
</script>
